<div class="about">
    <div class="banner">
        <app-banner-header [dataBanner]="dataBanner"></app-banner-header>
    </div>
    <div class="page-able">
        <router-outlet></router-outlet>
    </div>
</div>


